import { render, staticRenderFns } from "./announce_conc.vue?vue&type=template&id=6a120668&"
import script from "./announce_conc.vue?vue&type=script&lang=js&"
export * from "./announce_conc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports